import { createFileRoute } from '@tanstack/react-router';

import { PortfolioIndexPage } from '@/features/portfolio/routes/IndexPage';

export const Route = createFileRoute('/')({
  component: PortfolioIndexPage,
});
